var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rightColumn"},[(
      _vm.$store.state.conversation.activeConversation.ConversationID !== undefined
    )?_c('RightColumnTopActionBar'):_vm._e(),_c('MessagesContainer'),_c('transition',{attrs:{"name":"fade"}},[(
        _vm.$store.state.conversation.activeConversation.uploaders !== undefined
      )?_c('div',[(
          _vm.isChatAttachmentUploadEnabled &&
          _vm.$store.state.conversation.activeConversation.uploaders.imageUploader
            .isVisible === true
        )?_c('ImageUploader',{attrs:{"image-uploader":_vm.$store.state.conversation.activeConversation.uploaders.imageUploader,"conversation-i-d":_vm.$store.state.conversation.activeConversation.ConversationID}}):_vm._e(),(
          _vm.isChatAttachmentUploadEnabled &&
          _vm.$store.state.conversation.activeConversation.uploaders.documentUploader
            .isVisible === true
        )?_c('DocumentUploader',{attrs:{"document-uploader":_vm.$store.state.conversation.activeConversation.uploaders.documentUploader,"conversation-i-d":_vm.$store.state.conversation.activeConversation.ConversationID}}):_vm._e()],1):_vm._e()]),(_vm.$store.state.display.emojiKeyboard.isShown)?_c('EmojiKeyboard'):_vm._e(),_c('ReplyMessageBar'),(
      _vm.$store.state.conversation.activeConversation.ConversationID !== undefined
    )?_c('InputMainBar'):_vm._e(),(
      _vm.$store.state.conversation.activeConversation.ConversationID === undefined
    )?_c('NoActiveConversation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }